// extracted by mini-css-extract-plugin
export default {"wrapper":"layout_wrapper__mZ26x","mainArea":"layout_mainArea__J++cX","mainContent":"layout_mainContent__DU5Qd","menuButton":"layout_menuButton__o3W-o"};